<template>
  <div class="main">
  <el-breadcrumb separator-class="el-icon-arrow-right">
<el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
<el-breadcrumb-item>导航栏管理</el-breadcrumb-item>
<el-breadcrumb-item>一级导航栏页面</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
  <el-button type="primary" @click="showAddNavigation=true">添加一级导航栏</el-button>
  <el-table
  :data="infoList"
  border
  style="width: 100%">
  <el-table-column
    prop="info_ID"
    label="ID"
    width="100">
  </el-table-column>
  <el-table-column
    prop="info_NAME"
    label="名字"
    width="130">
  </el-table-column>
  <el-table-column
    width="180"
    prop="disp_ORDER"
    label="顺序">
  </el-table-column>
  <el-table-column
    label="操作"
    width="250">
      <template slot-scope="scope" >
<el-button  @click="deleteInfoByID(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<!-- <el-button  icon="el-icon-aim" size="small" @click="showExcelByHeadId(scope.row)"></el-button> -->
<el-button  @click="inserHtml(scope.row)"  v-show="scope.row.isMenus"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjia"></use></svg></el-button>
<el-button  @click="updateNavigation(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
    </template>
  </el-table-column>
</el-table>
</el-card>
<el-dialog
title="一级导航添加"
:visible.sync="showAddNavigation"
width="50%">

<el-form :model="addForm" ref="addForms" :rules="addInfoRules" label-width="200px" class="demo-dynamic">
  <el-form-item label="名称：" prop="INFO_NAME">
  <el-input  v-model="addForm.INFO_NAME"></el-input>
</el-form-item>

<el-form-item label="顺序：" prop="DISP_ORDER">
  <el-input type="number" oninput="if(value.length>3)value=value.slice(0,3)" v-model="addForm.DISP_ORDER"></el-input>
</el-form-item>
</el-form>
<div >
  <el-button type="primary" @click="submitAddForm()">提交</el-button>
  <el-button @click="showAddNavigation = false">取 消</el-button>
</div>

</el-dialog>

<el-dialog
title="一级导航修改"
destroy-on-close
:visible.sync="updataNav"
width="50%">

<el-form :model="updateForm" ref="addForms" :rules="addInfoRules" label-width="200px" class="demo-dynamic">
  <el-form-item label="名称：" prop="INFO_NAME">
  <el-input  v-model="updateForm.INFO_NAME"></el-input>
</el-form-item>

<el-form-item label="顺序：" prop="DISP_ORDER">
  <el-input type="number" oninput="if(value.length>3)value=value.slice(0,3)" v-model="updateForm.DISP_ORDER"></el-input>
</el-form-item>
</el-form>
<div>
  <el-button type="primary" @click="submitupdateForm()">提交</el-button>
  <el-button @click="updataNav = false">取 消</el-button>
</div>

</el-dialog>
</div>
</template>

<script>
export default {
  created(){
      this.getEasyInfo()
  },
  data(){
      return{
     infoList:[],
     showAddNavigation:false,
     updataNav:false,
     addForm:{
      INFO_NAME:'',
      DISP_ORDER:'',
     },updateForm:{
      INFO_NAME:'',
      DISP_ORDER:'',
      INFO_ID:'',
     },
     addInfoRules:{
      INFO_NAME:[
      { required: true, message: '请输入名称', trigger: 'blur' },
        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
      ],
      DISP_ORDER:[  { required: true, message: '请输入顺序号', trigger: 'blur' },
      ],
     },
      }
  },methods:{
      getEasyInfo(){
          this.axios.post("/info/getEasyInfo")
      .then((resp) => {
        if (resp.data.status == 1) {
    
          this.infoList=resp.data.result
        } else {
          alert("拿取数据失败");
        }
      })
      .catch((err) => {
        this.$message.error("出错");
      });
      },deleteInfoByID(data){
        const that=this
      this.$confirm("确定删除？","提示",{
        confirmButtonText: "确认",//确认按钮文字更换
        cancelButtonText: "取消",//取消按钮文字更换
        showClose: true,//是否显示右上角关闭按钮
        type: "warning",//提示类型  success/info/warning/error
    }).then(function(){  
      that.axios.post("/info/deleteInfo?INFO_ID="+data.info_ID)
      .then((resp) => {
        if (resp.data.status == 1) {
          that.$message.success('删除成功')
          that.getEasyInfo()
        } else {
          alert("拿取数据失败");
        }
      })
      .catch((err) => {
        that.$message.error("出错");
      });
    }).catch(()=>{});
      },submitAddForm(){
        this.$refs.addForms.validate(resp=>{
          if(!resp)
          return
          const formData = new FormData()
    formData.append('INFO_NAME', this.addForm.INFO_NAME)
    formData.append('DISP_ORDER',  this.addForm.DISP_ORDER)
        let config = {headers: { "Content-Type": "application/json" }};    
        this.axios.post("/info/insertInfo",formData,config)
      .then((resp) => {
        if (resp.data.status == 1) {
          this.$message.success("添加成功")
          this.getEasyInfo()
          this.showAddNavigation=false
        } else {
          alert("拿取数据失败");
        }
      })
      .catch((err) => {
        this.$message.error("出错");
      });
        })
       
      },submitupdateForm(){
        this.$refs.addForms.validate(resp=>{
          if(!resp)
          return
          const formData = new FormData()
    formData.append('INFO_NAME', this.updateForm.INFO_NAME)
    formData.append('DISP_ORDER',  this.updateForm.DISP_ORDER)
    formData.append('INFO_ID',  this.updateForm.INFO_ID)
        let config = {headers: { "Content-Type": "application/json" }};    
        this.axios.post("/info/updateInfo",formData,config)
      .then((resp) => {
        if (resp.data.status == 1) {
          this.$message.success("修改成功")
          this.getEasyInfo()
          this.updataNav=false
        } else {
          alert("拿取数据失败");
        }
      })
      .catch((err) => {
        this.$message.error("出错");
      });
        })
      },
      updateNavigation(data){
        this.updataNav=true
        console.log(data)
      this.updateForm.INFO_NAME=data.info_NAME
      this.updateForm.DISP_ORDER=data.disp_ORDER
      this.updateForm.INFO_ID=data.info_ID
      }
  }

}
</script>

<style>
.main{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/work/bam/OneNavigation.vue